import React from 'react';
import './Header.css'
const Header = () => {
    return (
        // Section for Header 
        <div >
            <div className="header">
                <h1><samp className="title">Natok</samp> Actor Selection</h1>
                <p>Choose all actors that you want to cast in your upcoming Drama <strong>RoshikJaan</strong></p>
                <h5>Total Budget: BDT 150 Million</h5>
            </div>
        </div>
    );
};

export default Header;